module.exports = __webpack_public_path__ + "static/media/n.a863bcd4.png";